export const passwordCheckService = {
    config: {
        findCalcNamesUrl: "passwordstrength/findCalcNames",
        findFailureUrl: "passwordstrength/findFailedCalcs",
        skipCalcs: ["none"]
    },

    updateConfig: function(newConfig) {
        this.config = {...this.config, ...newConfig};
    },

    findCalcNames: function() {
        let urlParam = "";
        const skipCalcs = this.config.skipCalcs;
        for (var i = 0; i < skipCalcs.length; i++){
            if (i > 0){
                urlParam += "&";
            }
            urlParam += "skipCalcs=" + encodeURIComponent(skipCalcs[i]);
        }

        return fetch(this.config.findCalcNamesUrl + "?" + urlParam, {
            method: 'GET',
            headers: {
                Accept: "application/json"
            }
        }).then((response) => {
            return response.json();
        });
    },

    findFailureCalcs: function(monitoredFieldValues={}) {
        const skipCalcs = this.config.skipCalcs;
        // Password must be there, so just default it to blank.
        const param = {password: "", ...monitoredFieldValues, skipCalcs};

        let firstElement = true;
        let requestParam = "";
        for (var property in param){
            const propertyName = encodeURIComponent(property);
            const propertyValue = param[property];

            if (Array.isArray(propertyValue)){
                for (var i = 0; i < propertyValue.length; i++){
                    requestParam +=  (firstElement ? "" : "&")
                        + propertyName + "=" + encodeURIComponent(propertyValue[i]);
                    firstElement = false;
                }
            } else if (propertyValue === null || typeof propertyValue === 'undefined'){
              requestParam += (firstElement ? "" : "&") + propertyName + "=";
            } else {
                requestParam += (firstElement ? "" : "&")
                    + propertyName + "=" + encodeURIComponent(propertyValue);
            }
            firstElement = false;

        }
        return fetch(this.config.findFailureUrl, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': "application/x-www-form-urlencoded"
            },
            body: requestParam,
            credentials: 'same-origin'
        }).then((response) => {
            return response.json();
        });
    }
};
